import * as React from 'react';
import * as style from './style.css';

interface IMetroAndRoadsLayoutProps {
  children: React.ReactNode;
}

export const MetroAndRoadsLayout: React.FC<IMetroAndRoadsLayoutProps> = ({ children }) => {
  return (
    <div data-testid="MetroAndRoadsLayout" className={style['wrapper']}>
      {children}
    </div>
  );
};
